import styled from '@emotion/styled';

export const InlineFieldsContainer = styled.div`
  display: flex;
  justify-content: space-between;

  > div:first-of-type {
    flex-basis: calc(70% - 10px);
  }

  > div:nth-of-type(2) {
    flex-basis: 30%;
  }
`;
